import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'
import storeInit from 'initializations/pages/CharterPage'

export class Main extends AbstractView {
  constructor(domElementId) {
    return super(domElementId);
  }

  init() {
    storeInit.init("charterForm")

    const CharterForm = () => import(/* webpackChunkName: "charter-form" */ 'containers/Pages/CharterCargo/CharterForm')

    new Vue({
      el: "#" + this.elemId,
      store,
      render: h => h(CharterForm)
    })
  }
}
